import { useCallback } from 'react';
import { bridge } from 'shared/src/utils';

export const useLogClickSearch = (screenName: string) => {
  return useCallback(() => {
    bridge.logAnalyticsEvent({
      channel: ['firebase', 'facebook', 'amplitude', 'ablylog'],
      name: 'CLICK_SEARCH',
      analytics: {
        SCREEN: screenName,
      },
    });
  }, [screenName]);
};
